import { IntegrationEndpointVariable } from '@components/integrations/integrations-types';
import { SelectOption } from '@components/select';

export const extractRequestData = (
  data: Record<string, any>,
  variables: IntegrationEndpointVariable[]
) => {
  const prefix = 'requestData__';
  const requestData: { [key: string]: any } = {};

  const setArrayValues = (obj: any, path: (string | number)[], value: any) => {
    let current = obj;
    for (let i = 0; i < path.length - 1; i++) {
      const part = path[i];
      if (!current[part]) {
        if (isNaN(Number(path[i + 1]))) {
          current[part] = {};
        } else {
          current[part] = [];
        }
      }
      current = current[part];
    }
    current[path[path.length - 1]] = value;
  };

  Object.keys(data).forEach((key) => {
    if (key.startsWith(prefix)) {
      const newKey = key.substring(prefix.length);
      const value = data[key];
      if (value === undefined) return;
      let processedValue = value;
      if (typeof value !== 'object') {
        processedValue = { value, variables: {} };
      }
      const variable = variables.find((v) => v.name === newKey);
      if (variable) {
        if (variable.type === 'array_of_strings' && Array.isArray(value)) {
          const stringValues = (value as Array<string | { value?: string }>)
            .map((item) => (typeof item === 'string' ? item : item?.value ?? ''))
            .filter((entry) => entry.length > 0);
          requestData[newKey] = { value: stringValues, variables: {} };
        } else {
          requestData[newKey] = processedValue;
        }
      } else {
        const path = newKey.split('__').map((part) => (isNaN(Number(part)) ? part : Number(part)));
        setArrayValues(requestData, path, processedValue);
      }
    }
  });

  return requestData;
};

export const mapSavedValuesToSelectOptions = (
  savedValues: unknown,
  options: SelectOption[]
): SelectOption[] => {
  if (!Array.isArray(savedValues)) return [];
  return savedValues
    .map((savedValue) => options.find((option) => option.value === savedValue))
    .filter((option): option is SelectOption => option !== undefined);
};
